import styled from "@emotion/styled";
import { Badge, BadgeProps } from "@mui/material";

const StyledBadge = styled(Badge)<BadgeProps>(() => ({
  "& .MuiBadge-badge": {
    top: 21,
    borderRadius: 5,
    padding: "13px 9px",
  },
}));

export default StyledBadge;
